import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/lib/components/auth.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/lib/components/breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/lib/components/copy-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/lib/components/faq.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/lib/components/favorites.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/lib/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/lib/components/hanzi-block.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/lib/components/microsoft-clarity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/lib/components/navbar.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/lib/components/skeletons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/lib/components/text-audio-button.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/lib/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextUIProvider"] */ "/opt/buildhome/repo/node_modules/@nextui-org/system/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/packages/ui/src/theme-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/buildhome/repo/packages/ui/src/toaster.tsx");
